import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback } from 'react';
import { useFromStore } from '../../../plugins/utils/createStore';
export default function connectStore() {
  return function (Component) {
    return function (props) {
      var database = props.database,
          store = props.store,
          column = props.column,
          record = props.record;
      var fieldKey = database.getFieldKey(record.key, column.key);
      var fieldStore = useFromStore(store, fieldKey);
      var setStore = useCallback(function (items) {
        var currentStore = store.getItem(fieldKey) || {};
        var updatedStore = Object.keys(items).reduce(function (acc, key) {
          return _objectSpread({}, acc, _defineProperty({}, key, items[key]));
        }, currentStore);
        store.updateItem(fieldKey, updatedStore);
      }, [fieldKey, store]);
      return React.createElement(Component, Object.assign({}, fieldStore, {
        setStore: setStore,
        store: store
      }, props));
    };
  };
}